import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
//
//
//
//
//

import Drip from 'drip';
export default {
  name: 'go-order-page',
  props: {},
  data: function data() {
    return {
      sellChannel: (Drip.constant || {}).appType,
      isNative: Drip.UA.isNative
    };
  },
  mounted: function mounted() {},
  methods: {
    goOrder: function goOrder() {
      if (Drip.UA.IS_MAIDANBA) {
        this.$router.replace('/order-list');
      } else if (Drip.UA.IS_CMBAPP) {
        var _Drip$redirect;
        var redirUrl = (_Drip$redirect = Drip.redirect) === null || _Drip$redirect === void 0 ? void 0 : _Drip$redirect.getUrl('/myshow/#/order-list');
        location.href = redirUrl;
      } else {
        Drip.redirect('/myshow/#/order-list');
      }
    }
  }
};